import React, { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import { ToastContainer, toast } from "react-toastify";

// Styles
import "filepond/dist/filepond.min.css";
import "react-toastify/dist/ReactToastify.css";

// Optional FilePond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

export default function TrainingUpload() {
	const [fileName, setFileName] = useState("");
	const [isUploading, setIsUploading] = useState(false);
	const [files, setFiles] = useState([]);

	const showToastFromNotification = (notification) => {
		if (!notification) return;

		if (notification.startsWith("✅")) {
			toast.success(notification);
		} else if (notification.startsWith("⚠️")) {
			toast.warn(notification);
		} else if (notification.startsWith("❌")) {
			toast.error(notification);
		} else {
			toast.info(notification);
		}
	};

	const handleUpload = async (
		fieldName,
		file,
		metadata,
		load,
		error,
		progress,
		abort
	) => {
		// Block non-CSV files (by extension as fallback check)
		if (!file.name.toLowerCase().endsWith(".csv")) {
			toast.error("❌ Only .csv files are allowed.");
			error("Only CSV allowed");
			return abort();
		}

		setFileName(file.name);
		setIsUploading(true);

		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await fetch("/api/training-data", {
				method: "POST",
				body: formData,
			});

			if (!response.ok) {
				const errorText = await response.text();
				throw new Error(errorText);
			}

			const data = await response.json();
			showToastFromNotification(data.notification);
			load(file.name); // Let FilePond know the upload succeeded
		} catch (err) {
			console.error("Upload failed:", err);
			toast.error("❌ Failed to upload training data.");
			error("Upload failed");
		} finally {
			setIsUploading(false);
		}
	};

	return (
		<div style={{ padding: 20 }}>
			<h1>📂 Upload Training Data</h1>
			<p style={{ marginBottom: 10 }}>
				Drag a CSV file here or click to browse. It will be sent to{" "}
				<code>/api/training-data</code>.
			</p>

			<FilePond
				files={files}
				onupdatefiles={setFiles}
				className={`large-uploader `}
				allowMultiple={false}
				acceptedFileTypes={["text/csv", ".csv"]}
				fileValidateTypeLabelExpectedTypesMap={{ "text/csv": ".csv" }}
				allowFileTypeValidation={true}
				allowFileSizeValidation={true}
				maxFileSize="5MB"
				labelIdle='📂 Drag & Drop your CSV or <span class="filepond--label-action">Browse</span>'
				server={{ process: handleUpload }}
				instantUpload={true}
				disabled={isUploading}
			/>

			{fileName && <p>📄 Selected file: {fileName}</p>}
			{isUploading && <p>🔄 Uploading...</p>}

			<ToastContainer position="top-right" autoClose={5000} />
		</div>
	);
}
